import { capitalizeFirstLetter, DateFormats, formatDateToString } from '@core';
import { MyGameItem } from '../models';

export function groupMyGamesByMonth(items: readonly MyGameItem[]): Map<string, MyGameItem[]> {
  return items.reduce((acc: Map<string, MyGameItem[]>, item: MyGameItem) => {
    const key: string = capitalizeFirstLetter(formatDateToString(item.gameDateStart, DateFormats.MonthYear));
    const existing: MyGameItem[] = acc.get(key) ?? [];
    acc.set(key, [...existing, item]);
    return acc;
  }, new Map<string, MyGameItem[]>());
}
